<!--
 * @Descripttion: 
 * @Author: zcy
 * @Date: 2022-01-07 15:38:05
 * @LastEditors: zcy
 * @LastEditTime: 2022-01-18 17:11:37
-->
<template>
  <div class="page-main">
    <div class="page-type-switch">
      <div
        :class="pageType === 'time' ? 'type-activite' : ''"
        @click="pageType = 'time'"
      >
        实时存塘量
      </div>
      <div
        :class="pageType === 'month' ? 'type-activite' : ''"
        @click="pageType = 'month'"
      >
        月存塘成本
      </div>
    </div>
    <!-- 实时存塘量 -->
    <TimePage v-if="pageType === 'time'" />
    <!-- 月存塘成本 -->
    <MonthPage v-if="pageType === 'month'" />
  </div>
</template>

<script>
import MonthPage from "./month-page.vue";
import TimePage from "./time-page.vue";
export default {
  data() {
    return {
      pageType: "time", //time实时存塘量 month月存塘成本
      spanArr: [], //用于准备行合并的数组
      tableData2: [],
      tableData: [],
      tableDataTwo: [],
    };
  },
  components: {
    MonthPage,
    TimePage,
  },
  mounted() {
    this.getSpanArr(this.tableData);
  },
  methods: {
    // data是列表数据
    getSpanArr(data) {
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].id === data[i - 1].id) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
      // console.log(this.spanArr);
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // rowIndex 当前行索引
      // columnIndex 当前列索引
      // if判断中写的是“是否需要合并的列索引” 写到几就说明合并到第几列
      // columnIndex === 0 || columnIndex === 1 合并到第二列
      // columnIndex === 0 合并到第一列
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        console.log(`rowspan:${_row} colspan:${_col}`);
        return {
          // 0是隐藏 1是显示
          // [0,0] 表示这一行不显示
          // [1,1] 代表该行正常显示 不进行合并
          // [2,1] 表示行的合并数
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style lang="less" scoped></style>


